import { FetchSendTemplateMessageParams } from 'api/templates';
import { MassMessagingTaskLog, MassMessagingTaskType } from 'types/mass-messaging/tasks';
import { fetcher } from 'utils/axios';

export const fetchGetMassMessagingTasks = async (skip: number = 0, size: number = 100) => {
  try {
    const data = await fetcher('get', `/api/massMessaging/getCompanyMassMsgngTasks?size=${size}&skip=${skip}`, 'newapi');
    if (data)
      return data as {
        data: Array<MassMessagingTaskType>;
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in getMassMessagingTasks:', error);
    return null;
  }
};

export type FetchCreateUpdateMassMessagingTaskParams = {
  name: string;
  description: string | null;
  sendDate?: string | null;
  templateObject: FetchSendTemplateMessageParams | null;
  contacts: { resultUsersList: { [key: string]: any }[]; sendToBlackListed: boolean };
  sendWebHook?: boolean;
  massMessagingGroupId?: number | null;
  filePath?: string | null;
  templateFileName?: string | null;
  isDynamicVars: boolean;
  closeCall?: boolean | null;
  label?: string | null;
  assignee?: string | null;
};

export const fetchCreateUpdateMassMessagingTask = async (
  id: number | null,
  params: FetchCreateUpdateMassMessagingTaskParams,
) => {
  try {
    const data = await fetcher(
      'post',
      [
        `/api/massMessaging/createUpdateFunnerMassMessagingTaskContactList/${id || 'null'}`,
        {
          data: params,
        },
      ],
      'newapi',
    );
    if (data) return data as { result: boolean };
    else return null;
  } catch (error) {
    console.warn('Error in createMassMessagingTask:', error);
    return null;
  }
};

export const fetchDeleteMassMessagingTask = async (id: number) => {
  try {
    const data = await fetcher('post', `/api/massMessaging/deleteFunnerMassMessagingTask/${id}`, 'history');
    if (data) return data as { result: boolean };
    else return null;
  } catch (error) {
    console.warn('Error in deleteMassMessagingTask:', error);
    return null;
  }
};

export const fetchGetMassMessagingTaskLogs = async (id: number) => {
  try {
    const data = await fetcher('get', `/api/massMessaging/getMassMessagingRecipients/${id}`, 'newapi');
    if (data) return data as { result: boolean; recipients: Array<MassMessagingTaskLog>; message?: string };
    else return null;
  } catch (error) {
    console.warn('Error in getMassMessagingTaskLogs:', error);
    return null;
  }
};

export const fetchResendMassMessagingTaskMessage = async (id: string) => {
  try {
    const data = await fetcher('post', `/broadcasts/resendFailedBroadcastRecipient/${id}`, 'newapi');

    if (data)
      return data as {
        result: boolean;
        message?: string;
      };
    else return null;
  } catch (error) {
    console.warn('Error in resendMassMessagingTaskMessage:', error);
    return null;
  }
};

export const fetchResendFailedBroadcastTask = async (taskId: number) => {
  try {
    const data = await fetcher('post', `/api/massMessaging/resendFailedBroadcastTask/${taskId}`, 'newapi');

    if (data)
      return data as {
        result: boolean;
        message?: string;
        successCount?: number;
        errorCount?: number;
      };
    else return null;
  } catch (error) {
    console.warn('Error in resendFailedBroadcastTask:', error);
    return null;
  }
};
